import { Box, Card, Divider, Stack, TextField, Typography } from '@mui/material';
import React from 'react';
import { PatientSearchFromEHRDetails } from '../Model';
type Props = {
  patientDetails: PatientSearchFromEHRDetails;
};
function PatientInformation({ patientDetails }: Props) {
  return (
    <Card sx={{ p: 0, height: '100%' }}>
      <Box sx={{ bgcolor: 'primary.main', p: 2, color: 'white' }}>
        <Typography variant='h6'>Patient Information</Typography>
      </Box>
      <Box sx={{ p: 3 }}>
        <Stack spacing={2}>
          <Typography variant='subtitle2' fontWeight='bold'>
            Patient Name:
          </Typography>
          <Typography variant='body1'>
            {patientDetails?.patientName !== undefined
              ? patientDetails?.patientName.length !== 0
                ? patientDetails?.patientName
                : '---'
              : '---'}
          </Typography>
          <Divider />
          <Typography variant='subtitle2' fontWeight='bold'>
            Patient MRN:
          </Typography>
          <Typography variant='body1'>
            {patientDetails?.patientMRN !== undefined
              ? patientDetails?.patientMRN.length > 0
                ? patientDetails?.patientMRN
                : '---'
              : '---'}
          </Typography>
          <Divider />
          <Typography variant='subtitle2' fontWeight='bold'>
            Patient UUID:
          </Typography>
          <Typography variant='body1'>
            {patientDetails?.patientUUID !== undefined
              ? patientDetails?.patientUUID.length > 0
                ? patientDetails?.patientUUID
                : '---'
              : '---'}
          </Typography>
        </Stack>
      </Box>
    </Card>
  );
}

export default PatientInformation;
